module.exports = __webpack_public_path__ + "static/media/storybook_qasir_ui.f3116bd7.JPG";